import React from "react";
import "./ui.css";

const COLOR_TO_VARIANT = {
  primary: "primary",
  secondary: "secondary",
  success: "success",
  danger: "danger",
  info: "info",
  warning: "warning",
  light: "light",
  dark: "dark",
  link: "outline-primary",
};

const OUTLINE_VARIANT_MAP = {
  primary: "outline-primary",
  secondary: "outline-secondary",
  success: "outline-success",
  danger: "outline-danger",
  info: "outline-info",
  warning: "outline-warning",
  light: "outline-primary",
  dark: "outline-primary",
};

const SIZE_MAP = { xs: "xs", sm: "sm", md: "md", lg: "lg", table: "table" };

const RB_VARIANT_MAP = {
  primary: { color: "primary" },
  secondary: { color: "secondary" },
  success: { color: "success" },
  danger: { color: "danger" },
  info: { color: "info" },
  warning: { color: "warning" },
  light: { color: "light" },
  dark: { color: "dark" },
  link: { color: "primary", outline: true },
  "outline-primary": { color: "primary", outline: true },
  "outline-secondary": { color: "secondary", outline: true },
  "outline-success": { color: "success", outline: true },
  "outline-danger": { color: "danger", outline: true },
  "outline-info": { color: "info", outline: true },
};

function resolveVariant(color, outline, variant) {
  if (variant && RB_VARIANT_MAP[variant]) {
    const mapped = RB_VARIANT_MAP[variant];
    return resolveVariant(mapped.color, mapped.outline, null);
  }
  if (variant) return variant;
  if (outline) return OUTLINE_VARIANT_MAP[color] || "outline-primary";
  return COLOR_TO_VARIANT[color] || "primary";
}

const Button = React.forwardRef(function Button({
  children,
  color = "primary",
  variant,
  size,
  outline = false,
  icon,
  iconPosition = "left",
  iconOnly = false,
  disabled = false,
  type = "button",
  className = "",
  onClick,
  ...rest
}, ref) {
  const resolvedVariant = resolveVariant(color, outline, variant);
  const sizeClass = SIZE_MAP[size] || "sm";

  const classes = [
    "oh-btn",
    `oh-btn--${resolvedVariant}`,
    `oh-btn--${sizeClass}`,
    iconOnly ? "oh-btn--icon-only" : "",
    disabled ? "oh-btn--disabled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const iconEl = icon ? <span className="oh-btn__icon">{icon}</span> : null;

  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {iconOnly ? (iconEl || children) : (
        <>
          {iconPosition === "left" && iconEl}
          {children}
          {iconPosition === "right" && iconEl}
        </>
      )}
    </button>
  );
});

export default Button;
